<template>
  <v-container class="ma-0">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ma-0"
          fab
          dark
          color="green"
          v-bind="attrs"
          v-on="on"
          @click="importExcel"
          :loading="loading"
        >
          <v-icon dark>mdi-package-up</v-icon>
        </v-btn>
      </template>
      <span>Import</span>
    </v-tooltip>
    <alert-success
      :toggle-dialog="success"
      title="Import Success"
      message="Data was imported successfully"
    />
    <alert-error
      :toggle-dialog="error"
      title="Import Error!"
      :message="errorMessage"
    />
  </v-container>
</template>
<script>
  import readExcel from '@/extra-functions/readExcel.extra'
  import { mapState } from 'vuex'
  import stockRepository from '@/repositories/stock.repository'
  import { apiVars } from '@/extra-functions/api-helper.extra'
  import splrPdRepository from '@/repositories/supplier-product.repository'
  import { dateFormatMixin } from '@/views/dashboard/mixins/helper.mixins'
  import searchDelay from '@/extra-functions/searchDelay.extra'
  import { errorHandler } from '../../../../extra-functions/store.extra'

  const errorDelay = searchDelay(100)
  const successDelay = searchDelay(100)
  const { dialog } = require('electron').remote
  const getStockDelay = searchDelay()
  export default {
    name: 'import-stock',
    components: {
      alertSuccess: () => import('@/views/dashboard/components/AlertSuccess'),
      alertError: () => import('@/views/dashboard/components/AlertError'),
    },
    data () {
      return {
        loading: false,
        success: false,
        errorMessage: [],
        error: false,
        ...apiVars('stock'),
      }
    },
    created () {
      this.getStock()
    },
    computed: {
      ...mapState({
        storeId: state => state.settings.storeId,
        stockUpdated: state => state.stock.channelUpdate,
      }),
    },
    watch: {
      stockUpdated () {
        this.getStock()
      },
    },
    methods: {
      importExcel () {
        const options = {
          title: 'Import',
          filters: [{ name: 'Excel', extensions: ['xlsx'] }],
          buttonLabel: 'import',
        }
        dialog.showOpenDialog(null, options)
          .then(({ canceled, filePaths }) => {
            if (!canceled) {
              this.readExcel(filePaths[0])
            }
          })
      },
      async readExcel (filePath) {
        readExcel.loadExcel(filePath, this.importExcelFile)
      },
      getStock () {
        getStockDelay(() => {
          stockRepository.storeAll(this.storeId)
            .then(({ data }) => { this.stockList = data })
            .catch(e => { this.stockErrors = errorHandler(e) })
            .then(() => { this.stockLoading = false })
        })
      },
      importExcelFile (excelData) {
        this.errorMessage = []
        if (!this.loading) {
          this.loading = true
          const data = this.finalizeData(excelData)
          splrPdRepository.importExcel(data)
            .then(() => {
              this.success = true
              successDelay(() => { this.success = false })
            })
            .catch(e => {
              this.error = true
              errorDelay(() => { this.error = false })
              this.errorMessage = errorHandler(e)
            })
            .then(() => { this.loading = false })
        }
      },
      finalizeData (data) {
        return data.map(e => {
          return {
            ...e,
            store_id: this.storeId,
            stock_id: this.stockList[e.stock_code],
          }
        })
      },
    },
    mixins: [
      dateFormatMixin,
    ],
  }
</script>
